import React, { useEffect, useState } from "react"
import { Link, NavLink } from "react-router-dom"
import {
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Navbar,
  Row,
} from "reactstrap"
import search from "../../../assets/images/searchicon.png"
import logoLg from "../../../assets/images/logowhite.png"

import TopNavOffCanvas from "./TopNavOffCanvas"
import { useSelector } from "react-redux"
import ProfileMenu from "components/CommonForBoth/TopbarDropdown/ProfileMenu"
import SearchDropDown from "./SearchVideo"
import HomeIcon from "assets/images/homei.png"
import ModelSearch from "../Model/ModelSearch"

const links = [
  {
    id: "link2",
    title: "About",
    path: "/about",
  },
  {
    id: "link6",
    title: "The Dockie Awards",
    path: "/thedockies",
  },
  {
    id: "link5",
    title: "Video Vault",
    path: "/videovaults",
  },
]

const TopNavBar = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const { isAuth } = useSelector(state => state.auth)
  const toggle = () => setDropdownOpen(prevState => !prevState)
  const handleCloseDropdown = () => setDropdownOpen(false)
  const [searchModel, setSearchModel] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(typeof window !== "undefined" && window?.scrollY > 0)
    }
    handleScroll()
    typeof window !== "undefined" &&
      window.addEventListener("scroll", handleScroll)
    return () => {
      typeof window !== "undefined" &&
        window.removeEventListener("scroll", handleScroll)
    }
  }, [])
  const toggleModalSearch = () => setSearchModel(!searchModel)
  const onClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    // with navbar   <Navbar
    //   className={` header-blue-bg border-0 ${isScrolled ? "" : "bg-blac"}`}
    //   style={{
    //     zIndex: "1000",
    //   }}
    // >
    <section
      className={`header-blue-bg py-2 py-md-4 px-2 px-lg-3 ${
        isScrolled ? "" : "bg-blac"
      }`}
      style={{ zIndex: 1000 }}
    >
      <div className="px-2 px-lg-5 py-3">
        <Row className="align-items-center justify-content-center g-0">
          <Col xs="4" className="col-lg-2">
            <NavLink to="/" onClick={onClick}>
              <img src={logoLg} alt="logo" className="img-fluid ff-proxima" />
            </NavLink>{" "}
          </Col>

          <Col className="col-lg-8 d-none d-lg-block">
            <div className="d-flex align-items-center gap-3 justify-content-center">
              <ul className="nav gap-2 gap-sm-4 border border-secondary-subtle border-1 rounded-pill px-3-5 text-secondary fw-normal ff-proxima">
                <li className="nav-item ff-proxima">
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive
                        ? "ff-proxima text-yellow text-uppercase font-size-14 fw-normal"
                        : "ff-proxima text-white text-uppercase font-size-14 fw-normal"
                    }
                    onClick={onClick}
                  >
                    <img src={HomeIcon} className="d-block" />
                  </NavLink>
                </li>
                {links.map((link, indx) => (
                  <li key={link.id + indx} className="nav-item ff-proxima">
                    <NavLink
                      onClick={onClick}
                      to={link.path}
                      className={({ isActive }) =>
                        isActive
                          ? "ff-proxima text-yellow text-uppercase font-size-14 fw-normal"
                          : "ff-proxima text-white text-uppercase font-size-14 fw-normal"
                      }
                    >
                      {link.title}
                    </NavLink>
                  </li>
                ))}
              </ul>

              <div className="position-relative">
                <Dropdown
                  toggle={toggleModalSearch}
                  isOpen={dropdownOpen}
                  direction="down"
                >
                  <DropdownToggle className="btn border border-secondary-subtle bg-transparent rounded-pill border-1 px-3-5 dropdown-toggle-custom ff-proxima">
                    <img src={search} />
                  </DropdownToggle>
                </Dropdown>
              </div>
            </div>
          </Col>

          <Col className="d-none d-lg-block col-lg-2 text-end">
            <div className="text-end">
              {isAuth ? (
                <ProfileMenu titleColor="text-dark" />
              ) : (
                <Link to="/login">
                  <button className="btn btn-primary-yellow ff-proxima font-size-14 fw-bolder text-uppercase  d-inline-block px-2 py-0">
                    Join Our Community
                  </button>
                </Link>
              )}
            </div>
          </Col>

          <Col xs="8" className="d-block d-lg-none text-end">
            <TopNavOffCanvas showSearchModal={toggleModalSearch} />
            <ModelSearch show={searchModel} onCloseClick={toggleModalSearch} />
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default TopNavBar
